// extracted by mini-css-extract-plugin
module.exports = {"d2xDetailL":"L_d2xDetailL__DHHkc"};